module.exports = __webpack_public_path__ + "img/car_blue.d893ae1e.webp";